import { action, atom } from '@cloudio-saas/statex';
import { Page } from 'componentregistry';
import { Platform } from 'componentregistry/platform/Platform';
import { pageAtom } from 'designer/atoms';

export type TreeType = 'expressionTree' | 'designer' | 'treepopup';

export const TreeTypeDesigner: TreeType = 'designer';

export const itemIdPickerPathAtom = atom<string[]>({
  path: ['ui', 'options', 'itemIdPicker', 'path'],
  defaultValue: ['xxx'],
});

export const itemIdPickerOpenAtom = atom({
  path: ['ui', 'options', 'itemIdPicker', 'open'],
  defaultValue: false,
});
export const itemPickerFilterAtom = atom<string>({
  path: ['ui', 'options', 'itemIdPicker', 'filter'],
  defaultValue: '',
});

function collectItemIDs(page: Page, collect: string[], itemId: string) {
  const item = page[itemId];
  if (!item) {
    throw Error(`Missing item w/ id ${itemId} in collectItemIDs`);
  }
  collect.push(itemId);
  item.children.forEach((childId) => {
    collectItemIDs(page, collect, childId);
  });
}

export function cleanupOrphanItems(page: Page): [Page, string[]] {
  const pageItemIDs: string[] = [];
  collectItemIDs(page, pageItemIDs, 'root');
  const p = { ...page };
  const itemIds = Object.keys(p);
  const orphans: string[] = [];
  itemIds.forEach((itemId) => {
    if (pageItemIDs.indexOf(itemId) === -1) {
      delete p[itemId];
      orphans.push(itemId);
    }
  });
  return [p, orphans];
}

export const cleanupOrphanItemsAction = action(
  (
    { get, set },
    {
      appUid,
      pageId,
      platform,
    }: { appUid: string; pageId: string; platform: Platform },
  ) => {
    const page = get(pageAtom, { params: { appUid, pageId } });
    if (!page) return;
    const pageItemIDs: string[] = [];
    collectItemIDs(page, pageItemIDs, 'root');
    const [p, orphans] = cleanupOrphanItems(page);
    if (orphans.length) {
      platform.showWarning(
        `Removed ${orphans.length} orphan items! [${orphans.join(', ')}]`,
      );
    } else {
      platform.showSuccess('No orphan items. Page is clean!');
    }
    set(pageAtom, p, { params: { appUid, pageId } });
  },
);
